export default function setGrabCursor(moving) {
  var swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;

  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }

  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';

  if (swiper.isElement) {
    requestAnimationFrame(() => {
      swiper.__preventObserver__ = false;
    });
  }
}